import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';

// @ts-expect-error not migrated to TS yet
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import ListingLibResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CREATED_BY_DATE_THRESHOLD = '20230530';
export default function CustomUserCell({
  crmObject,
  propertyName
}) {
  const userId = getPropertyValue(crmObject, propertyName);
  const createdDate = getPropertyValue(crmObject, PROPERTIES.CREATED_AT);
  const createdByNotAvailable = I18n.moment(Number(createdDate)).isBefore(I18n.moment(CREATED_BY_DATE_THRESHOLD, 'YYYYMMDD'));
  if (!userId) {
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      gap: 4,
      children: [createdByNotAvailable && /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.frameworkTable.columns.userCell.tooltip"
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.frameworkTable.columns.userCell.noUser"
      })]
    });
  }
  return /*#__PURE__*/_jsx(ListingLibResolvedCell, {
    id: userId,
    objectType: USER
  });
}